import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Eating Disorders Assessment:',
    subLabel: '',
    field: 'WLPreNPedAssessment',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Have you experienced significant changes in your eating patterns or behaviors (e.g., restrictive eating, binge eating, purging) that are causing distress or impairment in your daily life?',
          type: 'single_select',
          options: [
            {
              key: 'significantChangesYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'significantChanges',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'significantChangesNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you been preoccupied with body image, weight, or shape in a way that is causing significant distress or impairment?',
          type: 'single_select',
          options: [
            { key: 'WLPreNPbodyImageYes', value: 'Yes' } ,
            { key: 'WLPreNPbodyImageNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you attempted to control your weight through extreme measures such as excessive exercise, fasting, or the use of laxatives or diuretics?',
          type: 'single_select',
          options: [
            {
              key: 'extremeMeasuresYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'extremeMeasures',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'extremeMeasuresNo', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    label: 'Emotional Eating Assessment:',
    subLabel: '',
    field: 'WLPreNPemotionalEatingAssessment',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 
            'Do you find yourself turning to food as a way to cope with negative emotions such as sadness, stress, anxiety, or boredom?',
          type: 'single_select',
          options: [
            { key: 'foodToCopeYes', value: 'Yes' } ,
            { key: 'foodToCopeNo', value: 'No' }
          ]
        },
        {
          label:
            'How often do you experience episodes of emotional eating? (e.g., daily, several times a week, occasionally)',
          type: 'text',
          level: 'top',
          name: 'WLPreNPHowOften',
          rows: 1
        },
        {
          label:
            'What types of foods do you typically crave or consume during emotional eating episodes?',
          type: 'text',
          level: 'top',
          name: 'WLPreNPcravings',
          rows: 1
        },
        {
          label:
            'Are there specific triggers or situations that tend to lead to emotional eating? (e.g., work stress, relationship issues, social events)',
          type: 'single_select',
          options: [
            {
              key: 'triggersYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'triggers',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'triggersNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you noticed a pattern of feeling guilty, ashamed, or out of control after engaging in emotional eating?',
          type: 'single_select',
          options: [
            {
              key: 'patternOfGuiltYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'patternOfGuilt',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'patternOfGuiltNo', value: 'No' }
          ]
        },
        { 
          label:
            'Do you feel a temporary sense of relief or comfort when engaging in emotional eating behaviors?',
          type: 'single_select',
          options: [
            { key: 'senseOfReliefYes', value: 'Yes' } ,
            { key: 'senseOfReliefNo', value: 'No' }
          ]
        },
        {
          label:
            'Have you tried other coping mechanisms or strategies to manage your emotions besides food? If yes, please describe them.',
          type: 'single_select',
          options: [
            {
              key: 'copingMechanismsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'copingMechanisms',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'copingMechanismsNo', value: 'No' }
          ]
        },
        {
          label:
            'How does emotional eating affect your overall well-being, physical health, and weight management goals?',
          type: 'text',
          level: 'top',
          name: 'WLPreNPwellBeing',
          rows: 1
        }
      ]
    }
  },
  {
    label: 'History and Patterns:',
    subLabel: '',
    field: 'WLPreNPHistoryandPatterns',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Have you experienced any significant life events, traumas, or major transitions that may have contributed to your emotional eating habits?',
          type: 'single_select',
          options: [
            {
              key: 'traumasYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'traumas',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'traumasNo', value: 'No' }
          ]
        },
        {
          label: 'How long have you been struggling with emotional eating, and have you noticed any changes in its intensity or frequency over time?',
          type: 'text',
          level: 'top',
          name: 'WLPreNPHowLong',
          rows: 1
        }, 
        { 
          label: 'Have you ever sought professional help or participated in any programs to address emotional eating or related concerns?',
          type: 'single_select',
          options: [
            {
              key: 'professionalHelpYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'professionalHelp',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'professionalHelpNo', value: 'No' }
          ]
        },
        {
          label: 'Have you noticed any specific thoughts or beliefs that accompany your emotional eating episodes?',
          type: 'single_select',
          options: [
            {
              key: 'beliefsYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'beliefs',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'beliefsNo', value: 'No' }
          ]
        },
        { 
          label: 'Are there any specific challenges or obstacles you face when trying to break the cycle of emotional eating?',
          type: 'single_select',
          options: [
            {
              key: 'obstaclesYes',
              value: 'Yes',
              answer: {
                type: 'list',
                items: [
                  {
                    type: 'text',
                    name: 'obstacles',
                    placeholder: 'Please Elaborate'
                  }
                ]
              }
            },
            { key: 'obstaclesNo', value: 'No' }
          ]
        }
      ]
    }
  }
];
export default questionsModels;
